import {computed, Ref, toValue} from "vue";
import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {birthdayGiftApi} from "@/container";

/**
 * The statistics and the scan list of one gift.
 */
const useGiftStatistics = (giftId: Ref<number> | number) => {
    const id = computed(() => toValue(giftId));

    const statistics = useSwr(
        () => cacheKey(`birthday-gifts/${id.value}/statistics`),
        () => birthdayGiftApi().statistics(id.value)
    );

    const scans = useSwr(
        () => cacheKey(`birthday-gifts/${id.value}/vouchers`),
        () => birthdayGiftApi().scans(id.value)
    );

    return {statistics, scans};
};

export default useGiftStatistics;
